<template>
  <ap-layout :state="state">
    <form @submit.prevent="onSubmit">
      <div class="ba-w-full md:ba-w-116 ba-mt-12">
        <div class="ba-flex ba-justify-center ba-mb-5">
          <div class="ba-w-14 ba-border ba-border-primary"></div>
          <div class="ba-w-14 ba-ml-2 ba-border ba-border-faint-weak"></div>
        </div>
        <ap-input
          v-for="(data, name) in fields"
          :key="name"
          v-model="form[name]"
          :disabled="formLoading"
          :name="$t(data.name)"
          :type="data.type"
          :error="data.highlightError"
          @focus="onFocusInput(name)"
        />
      </div>
      <ap-captcha
        v-if="showCaptcha"
        class="ba-mt-15"
        :result.sync="captchResult"
        :refresh.sync="refreshCaptcha"
      />
      <ap-error
        v-if="formFieldMessage || message"
        class="ba-w-full md:ba-w-116 ba-mt-5 ba-text-center ba--mb-10"
        :message="formFieldMessage || message"
      />

      <button
        class="ap-button-login ba-mt-15 ba-mx-auto ba-transition-all"
        type="submit"
        :disabled="isDisabled"
        :class="[
          isDisabled
            ? 'ba-bg-faint ap-button-login__disabled'
            : isHover && !isDisabled
            ? 'ba-bg-accent'
            : 'artek-gradient-light'
        ]"
        @mouseenter="isHover = true"
        @mouseleave="isHover = false"
      >
        {{ $t("button.next") }}
      </button>
    </form>
  </ap-layout>
</template>

<script>
import ApLayout from "@/components/artek/ap-layout";
import ApInput from "@/components/artek/ap-input";
import { registerMixin } from "@ba/visary-account-common-vue";
import { createSettings } from "@/utils/settings";
import ApCaptcha from "@/components/artek/ap-captcha";
import ApError from "@/components/artek/ap-error";
import formMessagesMixin from "@/mixins/form-messages-mixin";

export default {
  mixins: [registerMixin, formMessagesMixin],
  components: {
    ApError,
    ApCaptcha,
    ApLayout,
    ApInput
  },
  data() {
    return {
      isHover: false,
      fields: {
        firstName: {
          name: "register.formFirstName",
          type: "text",
          highlightError: false
        },
        lastName: {
          name: "register.formLastName",
          type: "text",
          highlightError: false
        },
        email: {
          name: "register.formEmail",
          type: "text",
          highlightError: false
        },
        password: {
          name: "register.formPasswd",
          type: "password",
          highlightError: false
        },
        repeatPassword: {
          name: "register.formRepeatPasswd",
          type: "password",
          highlightError: false
        }
      },
      formInvalidPassword: false
    };
  },
  computed: {
    formMessages() {
      return {
        undefined: this.$t("register.formUserAlreadyExists"),
        BadRequest: {
          password: {
            MinLength: this.passwordMinLength,
            MinCapitalLetters: this.passwordMinCapitalLetters,
            MinCursiveLetters: this.passwordMinCursiveLetters,
            MinDigits: this.passwordMinDigits,
            MinSpecialCharacters: this.passwordMinSpecialCharacters,
            MaxLength: this.passwordMaxLength
          }
        }
      };
    },
    message() {
      if (this.formFieldsRequired) {
        return this.$t("register.formFieldsRequired");
      }
      if (this.formInvalidEmail) {
        return this.$t("register.formInvalidEmail");
      }
      if (this.formInvalidPassword) {
        return this.$t("register.formInvalidPassword");
      }
      if (this.formInvalidComparePassword) {
        return this.$t("register.formInvalidComparePassword");
      }
      if (this.formError) {
        return this.$t("register.formError");
      }
      return "";
    },
    isDisabled() {
      return (
        Object.entries(this.fields).some((el) => this.form[el[0]] === "") ||
        this.formLoading ||
        (this.showCaptcha && !this.captchResult)
      );
    }
  },
  watch: {
    registerInfo() {
      const settings = createSettings(this.registerInfo?.clientId);
      if (!settings?.canRegister) {
        this.$router.replace({ name: "login", query: { state: this.state } });
      }
    }
  },
  methods: {
    onSubmit() {
      this.registerFormSubmit();
      this.showHighlightError();
    },
    onFocusInput(fieldName) {
      this.fields[fieldName].highlightError = false;
    },
    showHighlightError() {
      if (this.formFieldsRequired) {
        Object.entries(this.form).forEach(([name, value]) => {
          this.fields[name].highlightError = !value;
        });
        return;
      }
      if (this.formInvalidEmail) {
        this.fields.email.highlightError = true;
        return;
      }

      this.formInvalidPassword = this.form.password.length < 6;
      if (this.formInvalidPassword) {
        this.fields.password.highlightError = true;
        return;
      }

      if (this.formInvalidComparePassword) {
        this.fields.repeatPassword.highlightError = true;
      }
    }
  }
};
</script>
